const cache = new Map<string, SVGSVGElement | Error | undefined>()

export default cache
